import {
  ArrayProperty,
  BooleanProperty,
  JsonProperty,
  NumberProperty,
  ObjectProperty,
  PropertyType,
  StringProperty
} from 'pages/ManageSmartAssistant/Sections/ToolsSection/ToolConfigurationPanels/CustomApiRequestToolConfigurationPanel/JsonSchemaBuilder/properties/types';

export const PropertyFactory = {
  create: (type: PropertyType, description: string): JsonProperty => {
    switch (type) {
      case 'string':
        return PropertyFactory.createString(description);
      case 'number':
        return PropertyFactory.createNumber(description);
      case 'boolean':
        return PropertyFactory.createBoolean(description);
      case 'object':
        return PropertyFactory.createObject(description);
      case 'array':
        return PropertyFactory.createArray(description);
      default:
        throw new Error(`Unknown property type: ${type}`);
    }
  },

  createString: (description: string, enumValues?: string[]): StringProperty => {
    const property: StringProperty = {
      type: 'string',
      description
    };

    if (enumValues && enumValues.length > 0) {
      property.enum = enumValues;
    }

    return property;
  },

  createNumber: (description: string): NumberProperty => ({
    type: 'number',
    description
  }),

  createBoolean: (description: string): BooleanProperty => ({
    type: 'boolean',
    description
  }),

  createObject: (description: string): ObjectProperty => ({
    type: 'object',
    description,
    properties: {},
    required: [],
    additionalProperties: false
  }),

  createArray: (description: string, items?: JsonProperty): ArrayProperty => {
    const property: ArrayProperty = {
      type: 'array',
      description
    };

    if (items) {
      property.items = items;
    }

    return property;
  }
};
